/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/daily_purchases_by_purchase_names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsDailyPurchasesByPurchaseNames } from "./constants";
import type { AppsAppGroupIdChartsDailyPurchasesByPurchaseNamesResult } from "./types";

export const getAppsAppGroupIdChartsDailyPurchasesByPurchaseNames = reactQueryFetcherAdapter(
  appsAppGroupIdChartsDailyPurchasesByPurchaseNames,
  (
    signal: AbortSignal,
    appGroupId: string,
    appIds: string[],
    startDate: number,
    endDate: number,
    keys: string[]
  ): Promise<AppsAppGroupIdChartsDailyPurchasesByPurchaseNamesResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/daily_purchases_by_purchase_names`,
      "GET",
      { app_ids: appIds, start_date: startDate, end_date: endDate, keys },
      { signal }
    );
  }
);
